<p-accordion [multiple]="true">
  <!-- <p-accordionTab header="Prioridade de Cobranca por plano de assinatura">
    <form
      class="form-b4a form-b4a__vertical config-payment-priority"
      (submit)="$event.preventDefault() && savePaymentPriority()"
    >
      <app-drag-drop-list
        [list]="paymentPriorityList"
        [template]="priorityItemTemplate"
        (listChanged)="onPaymentPriorityReordered($event)"
        [permission]="permission()"
        [rowItems]="1"
      />

      <ng-template #priorityItemTemplate let-item="data">
        <span class="drag-handle" cdkDragHandle>
          <i class="pi pi-bars"></i>
        </span>
        <span class="priority-badge">
          {{ paymentPriorityList.indexOf(item) + 1 }}
        </span>
        <span class="priority-label">
          {{ subscriptionNameMap.get(item.subscriptionTypeId || 0) }} -
          {{ subscriptionTypeNameMap.get(item.subscriptionTypeId || 0) }}
        </span>
      </ng-template>

      <div class="buttons">
        <p-button
          label="Salvar prioridades"
          type="submit"
          *ngIf="permission()"
        />
        <p-button
          label="Redefinir ordem"
          severity="secondary"
          [outlined]="true"
          (onClick)="resetPaymentPriorityOrder()"
          *ngIf="permission()"
        />
      </div>
    </form>
  </p-accordionTab> -->

  <p-accordionTab header="Configuracao de Fallback Anual/Mes">
    <form
      *ngIf="anualMonthlyForm && anualMonthlyConfigs.length"
      [formGroup]="anualMonthlyForm"
      class="form-b4a"
      (submit)="saveAnualMonthlyConfigs()"
    >
      <div class="p-float-label" *ngFor="let config of anualMonthlyConfigs">
        <p-inputNumber
          [formControlName]="config.configId!.toString()"
          [min]="1"
          [max]="31"
          [showButtons]="true"
        />
        <label [for]="config.configId!.toString()">
          {{ config.label ?? config.enumValue }}
        </label>
      </div>
      <div class="buttons full-w">
        <p-button
          label="Salvar configuracao"
          type="submit"
          *ngIf="permission()"
        />
      </div>
    </form>
  </p-accordionTab>

  <p-accordionTab header="Configuracao Pix agendado">
    <form class="form-b4a pix-recurrence-form">
      <span class="p-float-label">
        <p-inputNumber
          inputId="pixRecurrenceScheduleDay"
          [formControl]="pixRecurrenceScheduleControl"
          [min]="1"
          [max]="22"
          [useGrouping]="false"
          [showButtons]="true"
        />
        <label for="pixRecurrenceScheduleDay"
          >Dia maximo de agendamento (1 a 22)</label
        >
      </span>

      <small
        class="p-error"
        *ngIf="
          pixRecurrenceScheduleControl.invalid &&
          pixRecurrenceScheduleControl.touched
        "
      >
        Informe um dia valido entre 1 e 22.
      </small>

      <div class="buttons">
        <p-button
          label="Salvar configuracao"
          icon="pi pi-save"
          type="button"
          (onClick)="updatePixRecurrenceSchedule()"
          [disabled]="pixRecurrenceScheduleControl.invalid || !permission()"
        />
      </div>

      <div class="config-warning" *ngIf="!permission()">
        Somente usuarios com perfil FULL_ADMIN podem alterar essa configuracao.
      </div>
    </form>
  </p-accordionTab>
</p-accordion>
